import React, { useState } from "react";

const ProgramModulesEP = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState(null);
  const toggleSectionDetails = (index) => {
    setOpenSectionIndex((prev) => (prev === index ? null : index));
  };
  const sections = [
    {
      title: "Foundations of Politics (3 ECTS)",
      description: [
        "Explore political science fundamentals, ideologies, and systems, building a strong foundation for advanced governance and policy studies.",
      ],
    },
    {
      title: "Practical Politics in Africa (3 ECTS)",
      description: [
        "Analyse Africa’s political landscape, focusing on challenges, governance frameworks, and strategies for sustainable development.",
      ],
    },
    {
      title: "Comparative Political Systems: Learning from the West (3 ECTS)",
      description: [
        "Examine Western political systems to identify governance practices applicable to diverse contexts.",
      ],
    },
    {
      title: "Cultural Relations and Diplomacy (3 ECTS)",
      description: [
        "Study the role of culture in diplomacy and its impact on fostering global understanding and cooperation.",
      ],
    },
    {
      title: "Introduction to International Relations (3 ECTS)",
      description: [
        "Investigate core international relations theories and concepts, focusing on cooperation, conflict resolution, and global governance.",
      ],
    },
    {
      title: "Parliamentary Affairs (3 ECTS)",
      description: [
        "Understand parliamentary structures, processes, and governance frameworks, emphasising effective legislative practices.",
      ],
    },
    {
      title: "Knowledge, Power, and Politics in Human Science (3 ECTS)",
      description: [
        "Critically evaluate how knowledge production shapes political systems and governance globally.",
      ],
    },
    {
      title: "Promoting Inclusivity and Sustainable Governance (3 ECTS)",
      description: [
        "Develop strategies for inclusive governance and sustainable decision-making aligned with global development goals.",
      ],
    },
  ];

  return (
    <section
      id="program-modules-ep"
      className="p-3 scroll-m-14 md:scroll-mt-44 z-[4]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-center pb-5">
          <p className="border-b-4 border-sdorange inline-block text-center text-2xl font-bold">
            Programme Modules
          </p>
        </div>
        <div className="px-5">
          {sections.map((section, index) => (
            <div
              key={index}
              className="border-2 rounded-md bg-gray-400 bg-opacity-50 border-sdorange p-4 w-full mb-6 cursor-pointer hover:bg-gray-300"
              onClick={() => toggleSectionDetails(index)}
            >
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-2">
                  <img
                    src="/image-fix/academic-programmes/certified-courses/icons/play-circle-svgrepo-com.svg"
                    alt="Play Icon"
                    className="h-6 w-6"
                  />
                  <h3 className="text-xl font-semibold">{section.title}</h3>
                </div>
                <div>
                  {openSectionIndex === index ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-gray-700"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 15l7-7 7 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-gray-700"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  )}
                </div>
              </div>
              {openSectionIndex === index && (
                <div className="mt-3 p-2 bg-sdbodywhiteywhitebodyywhitebody rounded shadow">
                  <ul className="list-disc pl-5">
                    {section.description.map((desc, idx) => (
                      <li key={idx} className="text-sm text-gray-600 mb-2">
                        {desc}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramModulesEP;
